import { AgentLockCodeTypeEnum } from "./LockCodeTypeEnum";

export class AgentInfo {
    /** Nome dell'installazione a cui ci stiamo riferendo */
    installationName: string = null;

    /** Agent version */
    version: string = null;

    /** Versione del sistema operativo */
    osVersion: string = null;

    /** Ip */
    ip: string = null;

    /** Data dell'ultima connessione */
    lastMessage: Date = null;

    /** Lock code */
    lockCode: AgentLockCodeTypeEnum = AgentLockCodeTypeEnum.None;

    /** Agent lock code Timestamp */
    lockCodeTimestamp: Date = null;

    /**Mac address 1 */
    macAddress1: string = null;

    /**Mac address 1 last message */
    macAddress1LastMessage: Date = null;

    /**Mac address 2 */
    macAddress2: string = null;

    /**Mac address 2 last message */
    macAddress2LastMessage: Date = null;

    /** Remote Ip */
    remoteIp: string = null;

    /** Remote port */
    remotePort: number = -1;

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.Version) this.version = obj.Version;
        if (obj.OsVersion) this.osVersion = obj.OsVersion;
        if (obj.Ip) this.ip = obj.Ip;
        if (obj.LastMessage) this.lastMessage = obj.LastMessage;
        if (Object.values(AgentLockCodeTypeEnum).includes(obj.LockCode)) this.lockCode = obj.LockCode;
        if (obj.LockCodeTimestamp) this.lockCodeTimestamp = obj.LockCodeTimestamp;
        if (obj.MacAddress1) this.macAddress1 = obj.MacAddress1;
        if (obj.MacAddress1LastMessage) this.macAddress1LastMessage = obj.MacAddress1LastMessage;
        if (obj.MacAddress2) this.macAddress2 = obj.MacAddress2;
        if (obj.MacAddress2LastMessage) this.macAddress2LastMessage = obj.MacAddress2LastMessage;
        if (obj.RemoteIp) this.remoteIp = obj.RemoteIp;
        if (obj.RemotePort) this.remotePort = obj.RemotePort;
    }
}
